import { useHistory } from "react-router-dom";
import axios from "axios";

const Authen = {
  requireLogin: () => {
    let history = useHistory();

    if(sessionStorage.authen === undefined) {
      history.push("/admin/login");
      return false;
    }
    else {
      let authen = JSON.parse(sessionStorage.authen);

      axios.post(process.env.REACT_APP_API_URL + "/admin/me", {
        "api_key": process.env.REACT_APP_API_KEY,
        "token": authen.token
      })
      .then((res) => {
        let { status, data } = res.data;
        if(status == 1) {
          return true;
        }
        else {
          sessionStorage.removeItem("authen");
          history.push("/admin/login");
          return false;
        }
      })
      .catch((ex) => {
        console.log(ex);
        sessionStorage.removeItem("authen");
        history.push("/admin/login");
        return false;
      });
      return true;
    }
  },
  isLogin: async () => {
    if(sessionStorage.authen === undefined) {
      return false;
    }
    else {
      let authen = JSON.parse(sessionStorage.authen);

      await axios.post(process.env.REACT_APP_API_URL + "/admin/me", {
        "api_key": process.env.REACT_APP_API_KEY,
        "token": authen.token
      })
      .then((res) => {
        let { status, data } = res.data;
        if(status == 1) {
          return true;
        }
        else {
          sessionStorage.removeItem("authen");
          return false;
        }
      })
      .catch((ex) => {
        console.log(ex);
        //sessionStorage.removeItem("authen");
        return false;
      });
      //return true;
    }
  },
  getProfile: (token) => {
    return axios.post(process.env.REACT_APP_API_URL + "/admin/me", {
      "api_key": process.env.REACT_APP_API_KEY,
      "token": token
    });
  }
};

export default Authen;
